<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                  $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">{{
                  $t("configuracionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'menus-carta' }">{{
                  "Menús carta"
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ action }} menú carta
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <vue-tabs>
            <v-tab :title="$t('basico')">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nombreMenu"><strong>{{ $t("nombre") }}</strong>
                          <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="nombreMenu" v-model="menu.nombre" maxlength="127"/>
                        <em>
                          <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, menu.nombre.length) }}</span>
                        </em>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label><strong>{{ $t("referenciaProductoTpv") }}</strong>
                          <span style="color: red">*</span></label>
                        <el-select class="select-default" v-model="menu.idProduct" filterable remote reserve-keyword
                          :remote-method="searchProducto" :placeholder="$t('nombreDelProductoEnElTpv')">
                          <el-option v-for="p in listProductos" :key="p.id" :label="p.name" :value="p.id">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>{{ $t("categoria") }}</strong>
                          <span style="color: red">*</span></label>

                        <el-select class="select-default" size="large" v-model="menu.idCategoria" filterable
                          :placeholder="$t('seleccionaCategoria')">
                          <el-option v-for="cat in listCategories" class="select-primary" :value="cat.id"
                            :label="cat.nombre" :key="cat.id + '' + cat.nombre">
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label><strong>Tipo</strong> </label>

                        <el-select class="select-default" size="large" v-model="menu.idTipo" filterable
                          :placeholder="$t('seleccionaTipo')">
                          <el-option v-for="obj in listTipoProducto" class="select-primary" :value="obj.value"
                            :label="obj.label" :key="obj.value">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="descripcionProductoEditar"><strong>{{ $t("descripcion") }}</strong>
                        </label>
                        <input id="descripcionProductoEditar" v-model="menu.descripcion" class="form-control" maxlength="200"/>
                        <em>
                          <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(200, menu.descripcion.length) }}</span>
                        </em>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ordenProductoCarta"><strong>{{ $t("orden") }}</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.orden"
                          class="form-control" />
                      </div>
                    </div>
                  </div>
                  <label for="numeroPlatos">{{ $t('numeroDePlatos') }}</label>
                  <div class="row mt-1">

                    <div class="col-md-2 col-6">
                      <div class="form-group">
                        <label for="ordenProductoCarta" style="margin-left: 45%;"><strong>1º</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.numeroPrimeros"
                          class="form-control" />
                      </div>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="form-group">
                        <label for="ordenProductoCarta" style="margin-left: 45%;"><strong>2º</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.numeroSegundos"
                          class="form-control" />
                      </div>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="form-group">
                        <label for="ordenProductoCarta" style="margin-left: 45%;"><strong>3º</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.numeroTerceros"
                          class="form-control" />
                      </div>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="form-group">
                        <label for="ordenProductoCarta" style="margin-left: 45%;"><strong>4º</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.numeroCuartos"
                          class="form-control" />
                      </div>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="form-group">
                        <label for="ordenProductoCarta" style="margin-left: 45%;"><strong>5º</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.numeroQuintos"
                          class="form-control" />
                      </div>
                    </div>
                    <div class="col-md-2 col-6">
                      <div class="form-group">
                        <label for="ordenProductoCarta" style="margin-left: 45%;"><strong>6º</strong></label>
                        <input type="number" min="0" id="ordenProductoCarta" v-model="menu.numeroSextos"
                          class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("baja") }}</strong>
                        </label>
                        <el-switch v-model="menu.baja" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <strong>{{ $t("disponible") }}</strong>
                        </label>
                        <el-switch v-model="menu.noDisponible" active-color="#13ce66" inactive-color="#bcbcbc">
                        </el-switch>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nombreTarifa1"><strong>{{ $t("nombreTarifa1") }}</strong></label>
                          <input id="nombreTarifa1" v-model="menu.nombreTarifa1" class="form-control" maxlength="127"/>
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, menu.nombreTarifa1.length) }}</span>
                        </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa1"><strong>{{ $t("precioTarifa1") }}</strong></label>
                          <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                            currency-symbol-position="suffix" :precision="2" v-model="menu.precioTarifa1"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nombreTarifa2"><strong>{{ $t("nombreTarifa2") }}</strong></label>
                          <input id="nombreTarifa2" v-model="menu.nombreTarifa2" class="form-control" maxlength="127"/>
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, menu.nombreTarifa2.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa2"><strong>{{ $t("precioTarifa2") }}</strong></label>
                          <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                            currency-symbol-position="suffix" :precision="2" v-model="menu.precioTarifa2"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nombreTarifa3"><strong>{{ $t("nombreTarifa3") }}</strong></label>
                          <input id="nombreTarifa3" v-model="menu.nombreTarifa3" class="form-control" maxlength="127"/>
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, menu.nombreTarifa3.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa3"><strong>{{ $t("precioTarifa3") }}</strong></label>
                          <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                            currency-symbol-position="suffix" :precision="2" v-model="menu.precioTarifa3"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="nombreTarifa4"><strong>{{ $t("nombreTarifa4") }} </strong></label>
                          <input id="nombreTarifa4" v-model="menu.nombreTarifa4" class="form-control" maxlength="127" />
                          <em>
                            <span style="font-size: 12px!important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, menu.nombreTarifa4.length) }}</span>
                          </em>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="precioTarifa4"><strong>{{ $t("precioTarifa4") }}</strong></label>
                          <vue-numeric currency="€" inputmode="decimal" type="text" class="form-control"
                            currency-symbol-position="suffix" :precision="2" v-model="menu.precioTarifa4"
                            @keydown.native="$methods.evitarComasDecimales">
                          </vue-numeric>
                        </div>
                      </div>

                      <div class="col-md-12" v-if="!menu.imagen">
                        <template>
                          <div class="form-group">
                            <label><strong>{{ $t("imagen") }}</strong>
                              <span style="color: red">*</span></label>
                            <input class="form-control" type="file" @change="onFileChange" />
                            <br />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab v-if="idMenu" :title="$t('platos')">
              <label style="margin-left: 15px" for="opcion1">
                {{ $t('platosTip1') }} <br> {{ $t('platosTip2') }}

              </label>
              <div class="col-md-3">
                <br>
                <div class="row">
                  <div class="col-md-10" :class="primerPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <!--@focusout="guardarPlato(primerPlato)"-->
                      <label><strong>{{ $t('primerPlato') }}</strong></label>
                      <input type="text" class="form-control" id="opcion1" @click="editandoPrimero = true"
                        v-model="primerPlato.nombre" v-bind:placeholder="$t('ENTRANTES...')" />
                    </div>
                  </div>
                  <div class="col-md-2 col-2" v-if="primerPlato.id != 0 && !editandoPrimero">
                    <br>
                    <button @click="eliminarPlato(primerPlato)" class="btn btn-danger mt-1">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                  <div class="col-md-2 col-2" v-else-if="primerPlato.nombre != ''">
                    <br>
                    <button @click="guardarPlato(primerPlato)" class="btn btn-success mt-1">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="segundoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t('segundoPlato') }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoSegundo = true"
                        v-model="segundoPlato.nombre" v-bind:placeholder="$t('PRIMEROS...')" />
                    </div>
                  </div>
                  <div class="col-md-2 col-2" v-if="segundoPlato.id != 0 && !editandoSegundo">
                    <br>
                    <button @click="eliminarPlato(segundoPlato)" class="btn btn-danger mt-1">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                  <div class="col-md-2 col-2" v-else-if="segundoPlato.nombre != ''">
                    <br>
                    <button @click="guardarPlato(segundoPlato)" class="btn btn-success mt-1">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="tercerPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t('tercerPlato') }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoTercero = true"
                        v-model="tercerPlato.nombre" v-bind:placeholder="$t('SEGUNDOS...')" />
                    </div>
                  </div>
                  <div class="col-md-2 col-2" v-if="tercerPlato.id != 0 && !editandoTercero">
                    <br>
                    <button @click="eliminarPlato(tercerPlato)" class="btn btn-danger mt-1">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                  <div class="col-md-2 col-2" v-else-if="tercerPlato.nombre != ''">
                    <br>
                    <button @click="guardarPlato(tercerPlato)" class="btn btn-success mt-1">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="cuartoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t('cuartoPlato') }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoCuarto = true"
                        v-model="cuartoPlato.nombre" v-bind:placeholder="$t('POSTRES...')" />
                    </div>
                  </div>
                  <div class="col-md-2 col-2" v-if="cuartoPlato.id != 0 && !editandoCuarto">
                    <br>
                    <button @click="eliminarPlato(cuartoPlato)" class="btn btn-danger mt-1">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                  <div class="col-md-2 col-2" v-else-if="cuartoPlato.nombre != ''">
                    <br>
                    <button @click="guardarPlato(cuartoPlato)" class="btn btn-success mt-1">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="quintoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t('quintoPlato') }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoQuinto = true"
                        v-model="quintoPlato.nombre" v-bind:placeholder="$t('...')" />
                    </div>
                  </div>
                  <div class="col-md-2 col-2" v-if="quintoPlato.id != 0 && !editandoQuinto">
                    <br>
                    <button @click="eliminarPlato(quintoPlato)" class="btn btn-danger mt-1">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                  <div class="col-md-2 col-2" v-else-if="quintoPlato.nombre != ''">
                    <br>
                    <button @click="guardarPlato(quintoPlato)" class="btn btn-success mt-1">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10" :class="sextoPlato.id != 0 ? 'col-10' : 'col-12'">
                    <div class="form-group">
                      <label><strong>{{ $t('sextoPlato') }}</strong></label>
                      <input type="text" class="form-control" id="opcion2" @click="editandoSexto = true"
                        v-model="sextoPlato.nombre" v-bind:placeholder="$t('...')" />
                    </div>
                  </div>
                  <div class="col-md-2 col-2" v-if="sextoPlato.id != 0 && !editandoSexto">
                    <br>
                    <button @click="eliminarPlato(sextoPlato)" class="btn btn-danger mt-1">
                      <i class="fa fa-trash-alt"></i>
                    </button>
                  </div>
                  <div class="col-md-2 col-2" v-else-if="sextoPlato.nombre != ''">
                    <br>
                    <button @click="guardarPlato(sextoPlato)" class="btn btn-success mt-1">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <br>
              </div>
            </v-tab>
            <v-tab v-if="idMenu" :title="$t('productos')" @click="getPlatosByMenu()">
              <label style="margin-left: 15px" for="productos">
                {{ $t('productosPlatosTip') }}
              </label>
              <br>
              <div class="col-md-12">
                <div class="row mt-3">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label><strong>{{ $t('seleccionaUnPlato') }}:</strong></label>
                      <el-select class="select-default" v-model="platoSeleccionado" :placeholder="'Nombre del plato'">
                        <el-option v-for="p in listPlatos" :key="p.id" :label="p.nombre" :value="p.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label><strong>{{ $t('producto') }}:</strong></label>
                      <el-select class="select-default" v-model="productoCarta" filterable remote reserve-keyword
                        :remote-method="searchProductoCarta" :placeholder="$t('producto')">
                        <el-option v-for="p in listProductosCarta" :key="p.id" :label="p.nameProducto" :value="p.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-md-1 col-12" v-if="productoCarta != null">
                    <br>
                    <button @click="anadirProductoAPlato(productoCarta.id)" class="btn btn-success mt-1 mb-3 w-100">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row mt-2">
                  <table class="table table-sm mb-4 table-bordered table-striped" v-if="listProductosPlato.length > 0">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("nombre") }}</th>
                        <th> Visibilidad </th>
                        <th>{{ $t('acciones') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="prod in listProductosPlato" :key="prod.id">
                        <td width="40%">{{ prod.nameProducto }}</td>
                        <td width="15%"><template v-if="prod.noMostrarSuelto == '1'">Sólo en menú</template><template
                            v-else>En menú y por separado</template></td>
                        <td width="5%" style="text-align: center;">
                          <span style="margin: auto;">
                            <router-link :to="{
                              name: 'producto-carta',
                              params: {
                                idBusiness: idBusiness,
                                idCarta: idCarta,
                                idProducto: prod.id,
                              },
                            }">
                              <i class="far fa-eye"></i>
                            </router-link>
                          </span>
                          <!--<button @click="eliminarProductoDePlato(prod.id)" class="btn btn-danger" style="margin-left: 25%">-->
                          <span style="color: red; margin-left: 25px;" @click="eliminarProductoDePlato(prod.id)">
                            <i class="fa fa-trash"></i>
                          </span>
                          <!--</button>-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br>
                </div>
              </div>
            </v-tab>
            <!--<v-tab v-if="tieneMulticanal" :title="'Conf. Avanzada Sinqro'">
              <div class="row">
                <div class="col-md-12">
                  <label
                    >Plataformas de venta en las que estará disponible:</label
                  >
                  <br />
                  <br />
                  <div class="d-flex justify-content-start flex-wrap">
                    <div
                      v-for="agencia in listAgencias"
                      :key="'agenciaid' + agencia.id"
                    >
                      <el-checkbox
                        :style="
                          'min-width: 120px !important; margin-right: 15px;'
                        "
                        v-model="agencia.checked"
                        :label="agencia.nombreCanal"
                        border
                      >
                      </el-checkbox>
                    </div>
                  </div>
                  <br />
                  <small
                    >* Recuerda que los precios para la plataforma de venta de
                    NumierPEDIDOS se configuran en la pestaña "Básico".</small
                  >
                  <br />
                  <div class="card">
                    <div
                      v-for="producto in listProductosAgencias"
                      :key="'productoagenciaid' + producto.idProductAgencia"
                    >
                      <h4>
                        <img
                          v-if="producto.nombreCanal"
                          :src="
                            require('@/assets/img/' +
                              producto.nombreCanal +
                              '.svg')
                          "
                          style="width: 40px"
                        />
                        {{ producto.nombreCanal }}
                      </h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifa1"
                              ><strong>Nombre</strong></label
                            >
                            <input
                              id="nameTarifaEditar1"
                              disabled
                              :value="nombreProducto"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa1"
                              ><strong>Precio</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price1"
                            >
                            </vue-numeric>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifaEditar2"
                              ><strong>Nombre de la variante 1</strong>
                              <span style="margin-left: 10px">
                                <i
                                  v-tooltip.top-center="tipNombreVariante"
                                  style="white"
                                  class="fa fa-info-circle"
                                >
                                </i>
                              </span>
                            </label>
                            <input
                              id="nameTarifaEditar2"
                              v-model="producto.namePrice2"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa2"
                              ><strong>Precio de la variante 1</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price2"
                            >
                            </vue-numeric>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifaEditar3"
                              ><strong>Nombre de la variante 2</strong>
                              <span style="margin-left: 10px">
                                <i
                                  v-tooltip.top-center="tipNombreVariante"
                                  style="white"
                                  class="fa fa-info-circle"
                                >
                                </i>
                              </span>
                            </label>
                            <input
                              id="nameTarifaEditar3"
                              v-model="producto.namePrice3"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa3"
                              ><strong>Precio de la variante 2</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price3"
                            >
                            </vue-numeric>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="nameTarifaEditar4"
                              ><strong>Nombre de la variante 3</strong>
                              <span style="margin-left: 10px">
                                <i
                                  v-tooltip.top-center="tipNombreVariante"
                                  style="white"
                                  class="fa fa-info-circle"
                                >
                                </i>
                              </span>
                            </label>
                            <input
                              id="nameTarifaEditar4"
                              v-model="producto.namePrice4"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="precioTarifa4"
                              ><strong>Precio de la variante 3</strong></label
                            >
                            <vue-numeric
                              currency="€"
                              inputmode="decimal"
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="2"
                              v-model="producto.price4"
                            >
                            </vue-numeric>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>-->
          </vue-tabs>
          <div>
            <button class="btn btn-primary" @click="saveMenu()">
              <i class="fa fa-check-square"></i> {{ $t("guardar") }}
            </button>
            <router-link :to="{ name: 'menus-carta' }">
              <button class="btn btn-danger">
                <i class="fa fa-window-close"></i>
                {{ $t("cancelar") }}
              </button>
            </router-link>


            <button v-if="this.idMenu" class="btn btn-google" @click="clonarMenuCarta()">
              <i class="fas fa-exchange-alt"></i> {{ $t("clonarMenu") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-copysub" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header" style="padding-bottom: 0px">
          <h5>{{ $t("copiarMateriaPrima") }}</h5>
        </div>
        <div class="modal-body" style="padding-top: 0px">
          1 - {{ $t("seleccioneQueTipoDeMateriasPrimasQuiereCopiar") }}

          <el-checkbox-group v-model="listTipo" style="margin-top: 5px">
            <div class="col-md-12">
              <el-checkbox :label="$t('bases')" key="0"></el-checkbox>
              <el-checkbox :label="$t('opcionales')" key="1"></el-checkbox>
              <el-checkbox :label="$t('extras')" key="2"></el-checkbox>
            </div>
          </el-checkbox-group>

          <hr />

          2 - {{ $t("seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas") }}
          <el-checkbox-group v-model="listcategoriesCopySub" style="margin-top: 5px">
            <div class="col-md-12" v-for="c in listCategories">
              <el-checkbox :label="c.id" :key="c.id">
                {{ c.nombre }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="showModalCopySub()" class="btn btn-primary">
              <i class="fa fa-check-square"></i> {{ $t("guardar") }}
            </button>
            <button @click="$modal.hide('modal-copysub')" class="btn btn-danger">
              <i class="fa fa-window-close"></i>
              {{ $t("cancelar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  CheckboxGroup,
  Checkbox,
  DropdownMenu,
  Button,
  Switch,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "MenuCarta",
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
  },
  created() {
    this.getCategoriesCarta();
    if (this.idMenu) {
      this.getMenuCarta();
      this.getPlatosByMenu();
    }

    this.action = this.idMenu
      ? this.$i18n.t("editar")
      : this.$i18n.t("nuevo");
  },
  data() {
    return {
      action: "",
      idMenu: this.$route.params.idMenu,
      idBusiness: this.$route.params.idBusiness,
      idCarta: this.$route.params.idCarta,
      menu: {
        idCategoria: 0,
        idProduct: "",
        idProductCarta: "",
        nombre: "",
        descripcion: "",
        imagen: "",
        idTipo: "",
        numeroPrimeros: 0,
        numeroSegundos: 0,
        numeroTerceros: 0,
        numeroCuartos: 0,
        numeroQuintos: 0,
        numeroSextos: 0,
        nombreTarifa1: "",
        precioTarifa1: 0,
        nombreTarifa2: "",
        precioTarifa2: 0,
        nombreTarifa3: "",
        precioTarifa3: 0,
        nombreTarifa4: "",
        precioTarifa4: 0,
        updated: "",
        orden: 999,
        noDisponible: false,
        baja: false,
      },

      listCategories: [],
      listProductos: [],
      listPlatos: [],
      listProductosCarta: [],
      img: "",

      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
        {
          value: "M",
          label: this.$t("mesa"),
        },
      ],

      //MATERIAS PRIMAS
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      listMateriasPrimas: [],
      listSearchMateriasPrimas: [],
      idMateriaPrima: "",
      tipoAnterior: "",
      //COPYSUB
      listTipo: [],
      listcategoriesCopySub: [],
      nombreMenu: "",
      loading: "",
      editandoPrimero: false,
      editandoSegundo: false,
      editandoTercero: false,
      editandoCuarto: false,
      editandoQuinto: false,
      editandoSexto: false,
      primerPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 1,
      },
      segundoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 2,
      },
      tercerPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 3,
      },
      cuartoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 4,
      },
      quintoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 5,
      },
      sextoPlato: {
        id: 0,
        idMenu: 0,
        nombre: "",
        numero: 6,
      },
      platoSeleccionado: {},
      productoCarta: null,
      listProductosPlato: [],
      listProductosPlatoId: [],
    };
  },
  watch: {
    platoSeleccionado: function (newVal, oldVal) {
      //this.listProductosPlato = [];
      this.listProductosPlatoId = [];
      this.productoCarta = null;
      this.getProductosByPlato();
    },
    "menu.nombre": function (newVal, oldVal) {
      this.nombreMenu = newVal;
    },
  },
  methods: {
    calculateNumberOfCharacters(total, length) { 
        return total - length;
    },
    keydown: function (event, event2) {
      if (event.keyCode != 229) {

        if (event.keyCode == 32 || event.keyCode == 188) {
          event.preventDefault();
        }
      }
    },
    guardarPlato(plato) {

      if (plato.nombre !== "") {

        switch (plato.numero) {
          case 1:
            this.editandoPrimero = false;
            break;
          case 2:
            this.editandoSegundo = false;
            break;
          case 3:
            this.editandoTercero = false;
            break;
          case 4:
            this.editandoCuarto = false;
            break;
          case 5:
            this.editandoQuinto = false;
            break;
          case 6:
            this.editandoSexto = false;
            break;

        }
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          plato: plato,
          idMenu: this.menu.id,
          idCarta: this.idCarta,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt
        };

        let vm = this;
        let controller = plato.id == 0 ? "guardarPlatoByMenu" : "actualizarPlato";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {

              vm.$notify({
                message:
                  "Plato" +
                  " " +
                  plato.nombre +
                  " actualizado " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.getPlatosByMenu();

            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      } else {
        swal({
          title: vm.$t("atencion"),
          text: vm.$t('noPuedeDejarEnBlancoElNombreDeUnPlato'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }

    },
    eliminarPlato(plato) {

      swal({
        title: this.$t('estaSeguroDeQueQuiereBorrarEstePlato'),
        text: this.$t('seBorraranTodasLasAsociacionesDeProductosConElMismo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: this.$t('siEstoySeguro'),
        cancelButtonText: this.$t('cancelar'),
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {

          if (plato.id != 0) {

            var config = {
              params: {
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
              plato: plato,
              idMenu: this.menu.id,
              idCarta: this.idCarta,
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt
            };

            let vm = this;
            let controller = "eliminarPlato"
            this.axios
              .post(
                this.$store.getters.apiUrl + "delivery/" + controller,
                params,
                config
              )
              .then(function (response) {
                if (response.data.response) {

                  switch (plato.numero) {
                    case 1:
                      vm.primerPlato = { id: 0, idMenu: 0, nombre: "", numero: 1 };
                      break;

                    case 2:
                      vm.segundoPlato = { id: 0, idMenu: 0, nombre: "", numero: 2 };
                      break;

                    case 3:
                      vm.tercerPlato = { id: 0, idMenu: 0, nombre: "", numero: 3 };
                      break;

                    case 4:
                      vm.cuartoPlato = { id: 0, idMenu: 0, nombre: "", numero: 4 };
                      break;

                    case 5:
                      vm.quintoPlato = { id: 0, idMenu: 0, nombre: "", numero: 5 };
                      break;

                    case 6:
                      vm.sextoPlato = { id: 0, idMenu: 0, nombre: "", numero: 6 };
                      break;

                  }
                  vm.$notify({
                    message:
                      vm.$t('plato') +
                      " " +
                      plato.nombre +
                      " " + vm.$t('eliminado') + " " +
                      vm.$t("correctamente"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });

                  vm.getPlatosByMenu();

                } else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
                vm.inProgress = false;
              });
          }

        }
      });

    },
    eliminarProductoDePlato(idProduct) {
      swal({
        title: this.$t('estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado'),
        text: this.$t('dejaraDeFormarParteDelMenuDeFormaInstantanea'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: this.$t('siEstoySeguro'),
        cancelButtonText: this.$t('cancelar'),
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {

          if (idProduct != 0) {

            var config = {
              params: {
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
              idProduct: idProduct,
              idPlato: this.platoSeleccionado,
              idCarta: this.idCarta,
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt
            };

            let vm = this;
            let controller = "eliminarProductCartaPlato"
            this.axios
              .post(
                this.$store.getters.apiUrl + "delivery/" + controller,
                params,
                config
              )
              .then(function (response) {
                if (response.data.response) {

                  vm.$notify({
                    message:
                      vm.$t('producto') +
                      " " + vm.$t('eliminado') + " " +
                      vm.$t("correctamente"),
                    icon: "nc-icon nc-check-2",
                    timeout: 2000,
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: "success",
                  });
                  vm.listProductosPlatoId = [];
                  vm.listProductosCarta = [];
                  vm.productoCarta = null;
                  vm.getProductosByPlato();

                } else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              })
              .catch(function (error) {
                console.log(error);
                vm.inProgress = false;
              });
          }

        }
      });
    },
    showModalCopySub() {
      if (
        this.listcategoriesCopySub.length !== 0 &&
        this.listTipo.length !== 0
      ) {
        swal({
          title: this.$t(
            "estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos"
          ),
          text: this.$t("estaOperacionNoSePuedeDeshacer"),
          type: "info",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("aceptarProceso"),
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.copySub();
          }
        });
      } else {
        swal({
          title: this.$t("atencion"),
          text: this.$t("necesitasMarcarAlMenosUnTipoYUnaCategoria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }
    },
    copySub() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idMenu: this.idMenu,
        idBusiness: this.idBusiness,
        listCategories: this.listcategoriesCopySub,
        listTipo: this.listTipo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "copySubCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("materiaPrimaCopiadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.$modal.hide("modal-copysub");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    getMenuCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idMenu: this.idMenu,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getMenusCartaById",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.menu = response.data.result;

            vm.searchProducto(vm.menu.nombreProductoRef);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCategoriesCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCategoriesCarta", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listCategories = response.data.result;
            if (!vm.idMenu) {
              vm.menu.idCategoria = response.data.result[0].id;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    searchProducto(query) {
      if (query !== "") {
        const controller = "searchProductsTpv";
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
            query: query
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              vm.listProductos = response.data.result.products;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    searchProductoCarta(query) {

      this.listProductosCarta = [];

      if (query !== "") {
        const controller = "searchProductosCarta";
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
            query: query
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
          .then(function (response) {
            if (response.data.response) {

              response.data.result.forEach(categoria => {
                categoria.productos.forEach(producto => {

                  if (!vm.listProductosPlatoId.includes(producto.id)) {
                    vm.listProductosCarta.push(producto);
                  }

                })
              })

            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getProductosByPlato() {

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idPlato: this.platoSeleccionado,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getProductsCartaByPlato", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProductosPlato = response.data.result;

            vm.listProductosPlato.forEach(producto => {
              vm.listProductosPlatoId.push(producto.id);
            })

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    anadirProductoAPlato() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idProduct: this.productoCarta,
        idPlato: this.platoSeleccionado,
        idCarta: this.idCarta,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt
      };

      let vm = this;
      let controller = "addProductCartaToPlato"
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {

            vm.$notify({
              message:
                "Producto añadido " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.productoCarta = null;
            vm.listProductosCarta = [];
            vm.getProductosByPlato();

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },


    clonarMenuCarta() {
      // console.log(this.menu)
      // console.log(this.idMenu)
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {

        idBusiness: this.idBusiness,
        idMenu: this.idMenu,
        idCarta: this.idCarta,
        menu: this.menu,
        jwt: this.$store.getters.jwt,
      };

      // console.log(this.params)

      let vm = this;
      let controller = "cloneMenuCarta";

      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function (response) {


          if (response.data.response) {
            vm.$notify({
              message: vm.$t("menuCopiadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            vm.idMenu = response.data.result;
            vm.$router.push({
              name: "menu-carta",
              params: { idBusiness: vm.idBusiness, idMenu: response.data.result },
            });

            // console.log(vm.idMenu)
            vm.getCategoriesCarta();
            vm.getMenuCarta();
            vm.getPlatosByMenu();

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.img = e.target.result;
      };
      reader.readAsDataURL(file);
      // vm.getBase64(file);
    },

    saveMenu() {
      if (!this.menu.imagen) {
        this.menu.editImage = true;
        this.menu.img = this.img;   
        this.menu.imagen = this.menu.img;
      
    // ?? seria  que  se ha borrado algo que si funcionaba 
      }

      if (this.checkEditarMenu()) {

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusiness: this.idBusiness,
          menu: this.menu,
          jwt: this.$store.getters.jwt,
          idCarta: this.idCarta,
        };

        let vm = this;
        let controller = this.idMenu
          ? "editarMenuCarta"
          : "nuevoMenuCarta";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {

              vm.$router.push({
                name: "menus-carta",
                params: { idBusiness: vm.idBusiness },
              });

              let notify = vm.$t("editado");
              vm.$notify({
                message:
                  "Menú" +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    checkEditarMenu() {
      var check = true;

      if (this.menu.nombre === "") {
        swal({
          title: this.$t("atencion"),
          text: "Rellene los campos obligatorios",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        check = false;
      }

      return check;
    },

    /*searchMateriasPrimasCarta(query) {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idProduct: this.idMenu,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "delivery/searchMateriasPrimasCartaByProductCarta/" +
            query,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listSearchMateriasPrimas = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },*/

    getPlatosByMenu() {

      this.listPlatos = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idMenu: this.idMenu,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl +
          "delivery/getPlatosByMenuCarta",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listPlatos = response.data.result;
            vm.platoSeleccionado = vm.listPlatos[0].id;

            vm.listPlatos.forEach(plato => {

              switch (plato.numero) {
                case 1:
                  vm.primerPlato = plato;
                  break;
                case 2:
                  vm.segundoPlato = plato;
                  break;
                case 3:
                  vm.tercerPlato = plato;
                  break;
                case 4:
                  vm.cuartoPlato = plato;
                  break;
                case 5:
                  vm.quintoPlato = plato;
                  break;
                case 6:
                  vm.sextoPlato = plato;
                  break;
              }

            });

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    /*addMateriaPrima() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idMateriaPrima: this.idMateriaPrima,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };
      this.idMateriaPrima = "";
      let vm = this;
      let controller = "addMateriaPrima";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.idMateriaPrima = "";

            vm.getMateriasPrimasByProduct();

            let notify = vm.$t("agregada");
            vm.$notify({
              message:
                vm.$t("relacion") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.searchMateriasPrimasCarta();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },*/
    /*addMateriaPrimaWhenEdit(materiaPrima) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        materiaPrima: materiaPrima,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "addMateriaPrimaWhenEdit";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          // console.log(response)
          if (response.data.response) {
            vm.idMateriaPrima = "";

            vm.getMateriasPrimasByProduct();

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("relacion") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },*/

    /*changeTipo(entrada, materiaPrima) {
      var constError = 0;

      if (entrada === 1) {
        if (this.tipoAnterior === "") {
          this.tipoAnterior = materiaPrima.tipo;
        } else {
          this.tipoAnterior = "";
        }
      } else {
        this.listMateriasPrimas.forEach(function(x) {
          if (
            x.idSubproduct === materiaPrima.idSubproduct &&
            x.tipo === materiaPrima.tipo
          ) {
            constError++;
          }
        });

        if (constError > 1) {
          materiaPrima.tipo = this.tipoAnterior;

          swal({
            title: this.$t("atencion"),
            text: this.$t("noPuedeHaberDosMateriasPrimasConElMismoTipo"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.eliminarCrearSubproducto(materiaPrima);
          //this.guardarMateriaPrimaByProductosCarta(materiaPrima);
        }
      }
    },*/
    /*eliminarCrearSubproducto(materiaPrima) {
      // console.log(materiaPrima)
      this.eliminarSubproduct(materiaPrima.id);
      this.addMateriaPrimaWhenEdit(materiaPrima);
    },*/
    /*eliminarSubproducto(index) {
      swal({
        title: this.$t("estasSeguroDeBorrarLaMateriaPrima"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siDeseoBorrarlo"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.eliminarSubproduct(index);
        }
      });
    },*/
    /*eliminarSubproduct(id) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        id: id,
        idBusiness: this.idBusiness,
        idProduct: this.idProducto,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "deleteMateriaPrimaByProductCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getMateriasPrimasByProduct();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },*/

    /*guardarMateriaPrimaByProductosCarta(obj) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        materiaPrima: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "editMateriaPrimaByProductCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("relacion") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },*/
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}

.tab-content {
  margin-top: 0px;
}

.el-switch {
  margin: 15px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Menus/MenuCarta.vue